<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <!-- shipment = models.ForeignKey(Shipment, on_delete=models.CASCADE, verbose_name="Embarque")
    vgm = models.DecimalField('vgm', max_digits=5, decimal_places=2)
    sag_sheet = models.CharField('Planilla SAG', max_length=100)
    sag_worker = models.ForeignKey(Worker, verbose_name="Contraparte SAG", on_delete=models.CASCADE) -->

        <b-col sm="10">
          <label>Instructivo de Embarque</label>
          <v-select
            :options="boardinginstructions"
            v-model="$v.waybillDataExportacion.shipment.$model"
            :state="
              $v.waybillDataExportacion.shipment.$dirty
                ? !$v.waybillDataExportacion.shipment.$error
                : null
            "
            label="text"
            :reduce="(text) => text.value"
            class="style-chooser"
          >
          </v-select>
        </b-col>

        <b-col sm="2" style="padding-top: 23px; margin-right: 0px">
          <b-button variant="primary" @click="seeInstruction">
            <b-spinner v-if="loading" variant="primary" small></b-spinner
            >Ver</b-button
          >
        </b-col>

        <b-col sm="12">
          <b-form-group label="Tara total del camion">
            <b-form-input
              type="text"
              :state="
                $v.waybillDataExportacion.vgm.$dirty
                  ? !$v.waybillDataExportacion.vgm.$error
                  : null
              "
              v-model="$v.waybillDataExportacion.vgm.$model"
              v-on:keyup="inputSoloNumeroDecimal"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="Planilla SAG">
            <b-form-input
              type="text"
              :state="
                $v.waybillDataExportacion.sag_sheet.$dirty
                  ? !$v.waybillDataExportacion.sag_sheet.$error
                  : null
              "
              v-model="$v.waybillDataExportacion.sag_sheet.$model"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="Contraparte SAG">
            <b-form-select
              :state="
                $v.waybillDataExportacion.sag_worker.$dirty
                  ? !$v.waybillDataExportacion.sag_worker.$error
                  : null
              "
              v-model="$v.waybillDataExportacion.sag_worker.$model"
              :options="workers"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </form>

    <b-modal
      v-model="modalShownBordingInstructive"
      centered
      size="lg"
      title="Instructivos de embarque"
      hide-footer
    >
      <component
        :is="componenteActual"
        :idBording="idBording"
        :shipment="shipment"
        :ref="report"
      ></component>
    </b-modal>
  </div>
</template>

<script>
import { required, numeric, decimal } from "vuelidate/lib/validators";
import { log } from "util";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ReportInstructivoEmbarqueMaritimo from "../ReportInstructivoEmbarqueMaritimo.vue";
import ReportInstructivoEmbarqueAereo from "../ReportInstructivoEmbarqueAereo.vue";

import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "formGuiaDespachoExportacion",
  props: ["waybillDataExportacion", "loadDateTable", "readOnly"],
  components: {
    vSelect,
    ReportInstructivoEmbarqueMaritimo,
    ReportInstructivoEmbarqueAereo
  },
  data() {
    return {
      loading: false,
      modalShownBordingInstructive: false,
      componenteActual: "",
      idBording: 0,
      shipment: "",
      workers: "",
      boardinginstructions: []
    };
  },
  validations: {
    waybillDataExportacion: {
      shipment: { required },
      vgm: { required, decimal },
      sag_sheet: { required, numeric },
      sag_worker: { required }
    }
  },
  mounted() {
    this.loadDataForm();
  },
  watch: {
    "waybillDataExportacion.shipment": function (val) {
      this.$emit("loadDateTable", val);
    }
  },
  methods: {
    seeInstruction() {
      if (this.waybillDataExportacion.shipment != "") {
        this.loading = true;
        this.$axios({
          method: "get",
          url:
            "/api/comex/shipment/" +
            this.waybillDataExportacion.shipment +
            "/detailed_shipment/"
        })
          .then((response) => {
            this.loading = false;
            //es maritimo
            if (response.data.shipment_type.id == 1) {
              this.modalShownBordingInstructive = true;
              this.idBording = response.data.id;
              this.shipment = response.data;
              this.componenteActual = "ReportInstructivoEmbarqueMaritimo";

              this.report = "report";
              this.$nextTick(function () {
                this.$refs.report.calcular();
              });
            }

            //es aereo
            if (response.data.shipment_type.id == 2) {
              this.modalShownBordingInstructive = true;
              this.idBording = response.data.id;
              this.shipment = response.data;
              this.componenteActual = "ReportInstructivoEmbarqueAereo";

              this.report = "report";
              this.$nextTick(function () {
                this.$refs.report.calcular();
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
          });
      } else {
        miniToastr.info("Debe seleccionar primero un instructivo de Embarque");
      }
    },
    getPallets(a) {
      console.log("aqui");
    },
    saveForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
    },
    loadDataForm() {
      this.$axios
        .get("/api/comex/shipment/getShipment/")
        .then((res) => {
          let objInfo = res.data;

          for (let i in objInfo) {
            this.waybillDataExportacion.shipment_type =
              objInfo[i].shipment_type.id;
            this.boardinginstructions.push({
              value: objInfo[i].id,
              text:
                objInfo[i].boarding_number + "-" + objInfo[i].shipment_type.name
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.$axios
        .get("/production/get_client_plants/")
        .then((res) => {
          this.workers = res.data.workers;
          this.workers.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    submit() {},
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  beforeMount() {}
};
</script>

<style scoped></style>
